<div class="relative" [style.width]="width">

  <button type="button" (click)="toggleDropdown()" [disabled]="disabled"
    class="flex items-center w-full h-[50px] px-3 py-2 bg-white border border-gray-200 rounded-lg cursor-pointer transition-all duration-200 shadow-sm hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 gap-3"
    [class.opacity-50]="disabled" [class.cursor-not-allowed]="disabled" [attr.aria-expanded]="dropdownOpen"
    [attr.aria-haspopup]="true" role="combobox" aria-label="Project selector">


    <div class="flex items-center justify-center w-7 h-7 bg-black rounded-md text-white flex-shrink-0">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
      </svg>
    </div>


    <div class="flex flex-col flex-1 min-w-0 text-left">
      <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide leading-none">Project</span>
      <span class="text-sm font-medium text-gray-900 leading-tight" [class.text-gray-400]="!selectedProject">
        {{ getDisplayText() }}
      </span>
    </div>




    <div class="flex items-center justify-center w-6 h-6 text-gray-400 transition-transform duration-200"
      [class.rotate-180]="dropdownOpen">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
      </svg>
    </div>
  </button>


  <div *ngIf="dropdownOpen"
    class="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50 overflow-hidden min-w-[400px]"
    [style.max-height]="maxHeight" role="listbox">


    <div class="flex border-b border-gray-200 bg-white h-12">
      <button (click)="switchTab('all')"
        class="flex-1 px-4 text-sm font-medium transition-colors duration-200 flex items-center justify-center gap-2 h-full"
        [class.text-blue-600]="activeTab === 'all'" [class.text-gray-500]="activeTab !== 'all'"
        [class.border-b-2]="activeTab === 'all'" [class.border-blue-600]="activeTab === 'all'"
        [class.border-transparent]="activeTab !== 'all'">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 12h.01" />
          <path d="M3 18h.01" />
          <path d="M3 6h.01" />
          <path d="M8 12h13" />
          <path d="M8 18h13" />
          <path d="M8 6h13" />
        </svg>
        All Projects
        <span
          class="inline-flex items-center justify-center px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full min-w-[20px]">
          {{ getAllProjectsCount() }}
        </span>
      </button>
      <button (click)="switchTab('favorites')"
        class="flex-1 px-4 text-sm font-medium transition-colors duration-200 flex items-center justify-center gap-2 h-full"
        [class.text-blue-600]="activeTab === 'favorites'" [class.text-gray-500]="activeTab !== 'favorites'"
        [class.border-b-2]="activeTab === 'favorites'" [class.border-blue-600]="activeTab === 'favorites'"
        [class.border-transparent]="activeTab !== 'favorites'">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path
            d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5" />
        </svg>
        Favorites
        <span
          class="inline-flex items-center justify-center px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full min-w-[20px]">
          {{ getFavoritesCount() }}
        </span>
      </button>
    </div>


    <div class="p-3 border-b border-gray-100 bg-gray-50">
      <div class="relative">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
        <input #searchInput type="text" [(ngModel)]="searchTerm" (input)="onSearchChange()"
          [placeholder]="searchPlaceholder"
          class="w-full pl-10 pr-4 py-2 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:outline-none transition-colors duration-200"
          autocomplete="off" aria-label="Search projects">
      </div>
    </div>


    <div class="max-h-[350px] overflow-y-auto">
      <div *ngFor="let project of filteredProjects; trackBy: trackByProject; let even = even"
        (click)="selectProject(project)"
        class="flex items-center px-5 py-3 cursor-pointer transition-colors duration-150 gap-3 border-b border-gray-100"
        [class.bg-white]="even" [class.bg-gray-50]="!even" [class.hover:bg-gray-100]="even"
        [class.hover:bg-gray-200]="!even" [class.bg-blue-50]="isProjectSelected(project)" role="option"
        [attr.aria-selected]="isProjectSelected(project)">

        <!-- Switch/Current Button -->
        <button *ngIf="!isProjectSelected(project)" (click)="selectProject(project)"
          class="px-2 py-1 text-xs font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100 hover:border-blue-300 transition-colors duration-200"
          aria-label="Switch to this project">
          Switch
        </button>
        <button *ngIf="isProjectSelected(project)" disabled
          class="px-2 py-1 text-xs font-medium text-gray-400 bg-gray-100 border border-gray-200 rounded-md cursor-not-allowed"
          aria-label="Current project">
          Current
        </button>

        <!-- Project Name -->
        <span class="text-sm font-medium text-gray-900 flex-1" [class.text-blue-700]="isProjectSelected(project)">{{
          project.project }}</span>

        <!-- Favorite Heart -->
        <button (click)="toggleFavorite(project, $event)"
          class="flex items-center justify-center w-6 h-6 text-gray-400 hover:text-red-500 transition-colors duration-200"
          [class.text-red-500]="isFavorite(project)" aria-label="Toggle favorite">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" [class.fill-current]="isFavorite(project)"
            [class.fill-none]="!isFavorite(project)" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" class="w-4 h-4">
            <path
              d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
          </svg>
        </button>
      </div>


      <div *ngIf="filteredProjects.length === 0 && searchTerm"
        class="flex flex-col items-center justify-center py-8 pb-4 text-gray-500 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6 text-gray-400 mb-2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
        </svg>
        <span class="text-sm">No projects found matching "{{ searchTerm }}"</span>
      </div>


      <div *ngIf="activeTab === 'favorites' && filteredProjects.length === 0 && !searchTerm"
        class="flex flex-col items-center justify-center py-8 px-4 text-gray-500 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="w-8 h-8 text-gray-400 mb-3">
          <path
            d="m14.479 19.374-.971.939a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5a5.2 5.2 0 0 1-.219 1.49" />
          <path d="M15 15h6" />
          <path d="M18 12v6" />
        </svg>
        <span class="text-sm font-medium text-gray-600 mb-1">No favorites yet</span>
        <span class="text-xs text-gray-400">Add favorites for quick access to your most-used projects</span>
      </div>


      <div *ngIf="projects.length === 0"
        class="flex flex-col items-center justify-center py-8 px-4 text-gray-500 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6 text-gray-400 mb-2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
        </svg>
        <span class="text-sm">No projects available</span>
      </div>
    </div>
  </div>
</div>